import Modal from "bootstrap/js/dist/modal";

document.addEventListener("turbo:load", function () {
  document
    .querySelectorAll("[data-ws-trainer-details-modal]")
    .forEach(function (element) {
      let trainerId = element.getAttribute("data-ws-trainer-details-modal");

      element.addEventListener("click", function (event) {
        if (!trainerId) return;
        fetch(`/api/trainers/${trainerId}`)
          .then(response => response.json())
          .then(data => {
            document.getElementById('trainerModalName').innerHTML = `${data.givenName} ${data.familyName}`;
            document.getElementById('trainerModalImage').setAttribute("src", data.image);
            document.getElementById('trainerModalBio').innerHTML = `${data.description}`;

            let trainerModal = new Modal(document.getElementById('trainerModal'), {
              keyboard: false
            });
            trainerModal.show();
          })
          .catch(error => console.error('Error:', error));

        return true;
      });
    });

});